import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";
import { AgentType, SecondaryAgentType } from "../../enums";

interface Props {
  type: AgentType | SecondaryAgentType;
  style?: React.CSSProperties;
}

export const AgentTypeTag = ({ type, style }: Props) => {
  const { t } = useTranslation();

  let color: string;

  switch (type) {
    case AgentType.NATURAL:
    case SecondaryAgentType.NATURAL:
      color = PresetColors.BLUE;
      break;
    case AgentType.SELF_EMPLOYED:
    case SecondaryAgentType.SELF_EMPLOYED:
      color = PresetColors.GOLD;
      break;
    case AgentType.LEGAL:
    case SecondaryAgentType.LEGAL:
      color = PresetColors.PURPLE;
      break;
  }

  return (
    <Tag
      style={{ minWidth: 40, flexShrink: 0, alignSelf: "center", flexGrow: 0, textAlign: "center", ...style }}
      color={color}
    >
      {t("agent.enums.type." + type)}
    </Tag>
  );
};
